// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3fz1y","dragIcon":"Choice_dragIcon__vpjvf","left":"Choice_left__-mdG4","input":"Choice_input__k6SqI"};